/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ percent: NonNullable<unknown> }} Audio_Description_Export_Progress_LabelInputs */

const en_audio_description_export_progress_label = /** @type {(inputs: Audio_Description_Export_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exporting - ${i?.percent}%`)
};

const fr_audio_description_export_progress_label = /** @type {(inputs: Audio_Description_Export_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportation - ${i?.percent}%`)
};

const de_audio_description_export_progress_label = /** @type {(inputs: Audio_Description_Export_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportieren - ${i?.percent}%`)
};

const it_audio_description_export_progress_label = /** @type {(inputs: Audio_Description_Export_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esportazione - ${i?.percent}%`)
};

const ru_audio_description_export_progress_label = /** @type {(inputs: Audio_Description_Export_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Экспорт - ${i?.percent}%`)
};

const es_audio_description_export_progress_label = /** @type {(inputs: Audio_Description_Export_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportando - ${i?.percent}%`)
};

const zh_cn2_audio_description_export_progress_label = /** @type {(inputs: Audio_Description_Export_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`导出 - ${i?.percent}%`)
};

const ja_audio_description_export_progress_label = /** @type {(inputs: Audio_Description_Export_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`エクスポート中 - ${i?.percent}%`)
};

const hi_audio_description_export_progress_label = /** @type {(inputs: Audio_Description_Export_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`निर्यात - ${i?.percent}%`)
};

const pt_pt2_audio_description_export_progress_label = /** @type {(inputs: Audio_Description_Export_Progress_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exportando - ${i?.percent}%`)
};

/**
* | output |
* | --- |
* | "Exporting - {percent}%" |
*
* @param {Audio_Description_Export_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_progress_label = /** @type {((inputs: Audio_Description_Export_Progress_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Progress_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_progress_label(inputs)
	if (locale === "de") return de_audio_description_export_progress_label(inputs)
	if (locale === "it") return it_audio_description_export_progress_label(inputs)
	if (locale === "ru") return ru_audio_description_export_progress_label(inputs)
	if (locale === "es") return es_audio_description_export_progress_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_progress_label(inputs)
	if (locale === "ja") return ja_audio_description_export_progress_label(inputs)
	if (locale === "hi") return hi_audio_description_export_progress_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_progress_label(inputs)
	return en_audio_description_export_progress_label(inputs)
});